/** Ключи кэша TanStack Query для данных пространства. */
export const keys = {
  all: (wid: string) => ['ws', wid] as const,
  sidebar: (wid: string) => ['ws', wid, 'sidebar'] as const,
  members: (wid: string) => ['ws', wid, 'members'] as const,
  directory: (wid: string) => ['ws', wid, 'directory'] as const,
  details: (wid: string, cid: string) => ['ws', wid, 'details', cid] as const,
  messages: (wid: string, cid: string) => ['ws', wid, 'messages', cid] as const,
  thread: (wid: string, rootId: string) => ['ws', wid, 'thread', rootId] as const,
  pins: (wid: string, cid: string) => ['ws', wid, 'pins', cid] as const,
  files: (wid: string, cid: string) => ['ws', wid, 'files', cid] as const,
  saved: (wid: string) => ['ws', wid, 'saved'] as const,
  todos: (wid: string) => ['ws', wid, 'todos'] as const,
  threads: (wid: string) => ['ws', wid, 'threads'] as const,
  activity: (wid: string) => ['ws', wid, 'activity'] as const,
  search: (wid: string, q: string, conversationId: string, authorId: string) => ['ws', wid, 'search', q, conversationId, authorId] as const,
  message: (wid: string, id: string) => ['ws', wid, 'message', id] as const,
  scheduled: (wid: string) => ['ws', wid, 'scheduled'] as const,
  channelTemplates: (wid: string) => ['ws', wid, 'channelTemplates'] as const,
  bookmarks: (wid: string, cid: string) => ['ws', wid, 'bookmarks', cid] as const,
  fileSearch: (wid: string, q: string, cid: string) => ['ws', wid, 'fileSearch', q, cid] as const,
  sent: (wid: string) => ['ws', wid, 'sent'] as const,
  unreads: (wid: string) => ['ws', wid, 'unreads'] as const,
  huddles: (wid: string) => ['ws', wid, 'huddles'] as const,
  conferences: (wid: string) => ['ws', wid, 'conferences'] as const,
  conferenceLobby: (wid: string, id: string) => ['ws', wid, 'conferences', id, 'lobby'] as const,
  apps: (wid: string) => ['ws', wid, 'apps'] as const,
  app: (wid: string, id: string) => ['ws', wid, 'apps', id] as const,
  myIntegrations: (wid: string) => ['ws', wid, 'myIntegrations'] as const,
  appCommands: (wid: string) => ['ws', wid, 'appCommands'] as const,
  audit: (wid: string, filters: Readonly<Record<string, string>>) => ['ws', wid, 'audit', filters] as const,
};
